<template>
  <div class="add-pay-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="680px" :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form ref="form" :model="params" label-width="150px" :label-position="labelPosition">
        <div class="form-flex-box">
          <el-form-item label="图标:" prop="img">
            <base-upload class="upload" :cover="params.img" :action="action" :wSize="90" :hSize="90" :width="'90px'"
              :height="'90px'" @successCallback="handleAvatarSuccess"></base-upload>
          </el-form-item>
        </div>

        <!-- <div class="form-flex-box" style="width: 300px">
          <el-form-item label="特权:" prop="privilege">
            <el-select
              v-model="params.privilege"
              placeholder="请选择特权"
              @change="privilegeFunc()"
              class="privileges"
            >
              <el-option
                v-for="item in privileges"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div> -->
        <div class="form-flex-box" style="width: 400px">
          <el-form-item label="特权名称:" prop="privilegeName">
            <el-input v-model="params.privilegeName" placeholder="请输入特权名称" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box" style="width: 400px">
          <el-form-item label="特权值:" prop="privilege">
            <el-input-number style="width: 250px;" v-model="params.privilege" placeholder="请输入特权值" size="small"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-flex-box" style="width: 400px">
          <el-form-item label="特权描述:" prop="privilegeDesc">
            <el-input type="textarea" rows="3" v-model="params.privilegeDesc" placeholder="请输入特权描述" size="small"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import { privilegeTypes } from "../../../../config/product";

export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title: "",
      flag: false,
      id: "",
      type: "",
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      params: {
        privilegeName: "",
        privilegeDesc: "",
        img: "",
        privilege: undefined,
      },
      privileges: privilegeTypes,
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.newProductBenefit();
          } else {
            this.editProductBenefit();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        img: "",
        privilegeDesc: "",
        privilege: undefined,
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑商品权益配置";
        this.params = { ...data };
        this.id = data.id;
        for (const p of this.privileges) {
          if (this.params.privilege === p.value) {
            this.params.privilegeName = p.label;
            continue;
          }
        }
      } else {
        this.title = "新增商品权益配置";
      }
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.img = res.data.coverImg;
    },
    privilegeFunc() {
      for (const p of this.privileges) {
        if (this.params.privilege === p.value) {
          this.params.privilegeName = p.label;
          continue;
        }
      }
    },
    // 新增商品
    newProductBenefit() {
      API.newProductBenefit(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑商品
    editProductBenefit() {
      let form = Object.assign(this.params, {
        id: this.id,
      });
      API.editProductBenefit(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-pay-box {
  ::v-deep .el-input {
    width: 250px;
  }

  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .privileges .el-input--suffix {
    width: 480px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
